let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ivb0y")).then(() => parcelRequire('hYmku'));